var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleBrand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8442 2C15.8902 2 15.9362 2 15.9848 2C16.0976 3.2211 15.5656 4.1335 14.919 4.79424C14.2846 5.45041 13.4159 6.08681 12.0107 5.99024C11.917 4.78663 12.4499 3.9419 13.0956 3.28269C13.6945 2.66834 14.7923 2.12165 15.8442 2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 16.7426C20 16.7565 20 16.7687 20 16.7817C19.6079 17.9778 19.0486 19.0029 18.366 19.9542C17.743 20.8178 16.9794 21.98 15.6161 21.98C14.438 21.98 13.6555 21.2171 12.4481 21.1962C11.171 21.1754 10.4686 21.8342 9.30087 22C9.16729 22 9.03372 22 8.90273 22C8.04524 21.875 7.35323 21.191 6.84908 20.5748C5.36249 18.7538 4.21372 16.4015 4 13.3914C4 13.0963 4 12.802 4 12.5069C4.09049 10.3526 5.12981 8.60099 6.51126 7.75211C7.24033 7.30076 8.24259 6.91624 9.35861 7.0881C9.83691 7.16275 10.3255 7.32766 10.7539 7.49084C11.1598 7.64795 11.6673 7.92657 12.1482 7.91181C12.474 7.90227 12.798 7.73128 13.1264 7.61063C14.0881 7.26083 15.0309 6.85982 16.2736 7.04817C17.7671 7.27559 18.8271 7.94393 19.4821 8.97509C18.2187 9.78492 17.2199 11.0053 17.3905 13.0893C17.5422 14.9824 18.6349 16.0899 20 16.7426Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleBrand);
export default __webpack_public_path__ + "static/media/apple-brand.eeffea1281e349dd47df1a3185fa38ca.svg";
export { ForwardRef as ReactComponent };